export default __webpack_public_path__ + "media/images/84-74431a60bf7d707a919a882e6c22cf75.jpg";